import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_chudy-logistyka/artifacts/e7s7h7u8_Screenshot%202026-04-22%20at%2011-24-34%2016759a71-7e1b-473a-ab3e-a44c0460777d.png%20%28PNG%20Image%201536%20%C3%97%201024%20pixels%29%20%E2%80%94%20Scaled%20%2890%25%29.png";

const links = [
  { to: "/o-mnie", label: "O mnie" },
  { to: "/oferta", label: "Oferta" },
  { to: "/kalkulator", label: "Kalkulator" },
  { to: "/ebooki", label: "E-booki" },
  { to: "/video", label: "Video" },
  { to: "/dlaczego-ja", label: "Dlaczego ja" },
  { to: "/kontakt", label: "Kontakt" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [location.pathname]);

  return (
    <header
      data-testid="main-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#0a0a0a]/92 backdrop-blur-xl border-b border-[rgba(212,169,74,0.18)]"
          : "bg-transparent"
      }`}
    >
      <div className="container-x flex items-center justify-between gap-6 py-4">
        <Link
          to="/"
          data-testid="nav-logo"
          className="flex items-center group shrink-0"
        >
          <img
            src={LOGO_URL}
            alt="Przemysław Chudy — Wsparcie w transporcie"
            className="h-14 md:h-16 w-auto object-contain transition-opacity group-hover:opacity-85"
          />
        </Link>

        <nav className="hidden lg:flex items-center justify-center gap-5 xl:gap-7 flex-1">
          {links.map((l) => {
            const active = location.pathname === l.to;
            return (
              <Link
                key={l.to}
                to={l.to}
                data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
                className={`nav-link whitespace-nowrap ${active ? "nav-link-active" : ""}`}
              >
                {l.label}
              </Link>
            );
          })}
        </nav>

        <div className="hidden lg:block shrink-0">
          <button
            data-testid="nav-cta-porozmawiajmy"
            onClick={() => navigate("/kontakt")}
            className="btn-gold"
          >
            Porozmawiajmy
            <span aria-hidden>→</span>
          </button>
        </div>

        <button
          data-testid="nav-mobile-toggle"
          className="lg:hidden text-[var(--gold)] p-2"
          onClick={() => setOpen((s) => !s)}
          aria-label="Menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div
          data-testid="nav-mobile-panel"
          className="lg:hidden border-t border-[rgba(212,169,74,0.18)] bg-[#0a0a0a]/96 backdrop-blur-xl"
        >
          <div className="container-x py-6 flex flex-col gap-1">
            {links.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                data-testid={`nav-mobile-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
                className="py-3 text-[15px] tracking-wide text-[#f5f1e8] border-b border-[rgba(212,169,74,0.1)] last:border-0"
              >
                {l.label}
              </Link>
            ))}
            <button
              onClick={() => navigate("/kontakt")}
              className="btn-gold mt-5"
              data-testid="nav-mobile-cta"
            >
              Porozmawiajmy →
            </button>
          </div>
        </div>
      )}
    </header>
  );
}
